<ng-template let-modal #confirmPostReaction>
  <div class="w-100 d-flex justify-content-center align-items-center flex-column">
    <p class="mb-2" style="color: var(--primary); font-weight: bold; font-size: 1.2rem">Please select your reaction:</p>

    <div class="w-100 d-flex justify-content-center">
      <button class="btn-outline-primary btn btn-sm like-btn rxn-btn mr-3" (click)="toggleUploadRxn(1)"
        [class.active]="uploadedImage?.myRxn === 1">{{ uploadedImage?.likeCounts }} <i
          class="fa fa-thumbs-up"></i></button>

      <button class="btn-outline-primary btn btn-sm dislike-btn rxn-btn" (click)="toggleUploadRxn(2)"
        [class.active]="uploadedImage?.myRxn === 2">{{ uploadedImage?.dislikeCounts }} <i
          class="fa fa-thumbs-down"></i></button>
    </div>
  </div>
</ng-template>

<ng-template let-modal #selectSubCategories>
  <div class="box">
    <label class="toggle">Select SubCategories</label>
    <div>
      <ng-container *ngFor="let i of mapSubCategories">
        <div class="box__item" [ngClass]="{ active: i.isChecked }">
          <input [id]="i?.categoryName" style="opacity: 1; width: 20px" type="checkbox" (change)="handleLoadProducts()"
            [(ngModel)]="i.isChecked" />
          <label [for]="i?.categoryName">{{ i?.categoryName | titlecase }}</label>
        </div>
      </ng-container>
    </div>
    <button class="my-button-3 mt-2" (click)="closeAllModals()"><i class="fa fa-save"></i> Done</button>
  </div>
</ng-template>

<div class="products">
  <div class="search-nearby">
    <input type="text" [(ngModel)]="search" placeholder="Look for Services" (focus)="getSearchSuggestions($event)"
      (keydown)="getSearchSuggestions($event)" (keydown.enter)="openSearchModal($event.target.value)" />
    <div class="search-nearby__button"><i class="fa-solid fa-search"></i></div>
  </div>
  <app-search-suggestion [searchSuggestions]="searchSuggestions"
    (suggestionClicked)="openSearchModal($event)"></app-search-suggestion>
  <div class="container">
    <!-- <div class="w-100">
      <div class="my-input w-100">
        <i class="fa-solid fa-search"></i>
        <div class="position-relative w-50">
          <input type="text" [(ngModel)]="search" placeholder="Look for Services" class="w-100" (focus)="getSearchSuggestions($event)" (keydown)="getSearchSuggestions($event)" (keydown.enter)="openSearchModal($event.target.value)" />
          <div class="position-absolute w-100" style="top: calc(100% + 0.2rem); z-index: 1000">
            <app-search-suggestion [searchSuggestions]="searchSuggestions" (suggestionClicked)="openSearchModal($event)"></app-search-suggestion>
          </div>
        </div>
      </div>
    </div> -->

    <div class="products__header">
      <div class="products__header--title">
        See What’s Near You
        <svg viewBox="0 0 800 800" fill="none">
          <path d="M800 0H0V800H800V0Z" fill="white" fill-opacity="0.01" />
          <path
            d="M400 733.333C400 733.333 650 533.333 650 316.666C650 178.595 538.072 66.6665 400 66.6665C261.928 66.6665 150 178.595 150 316.666C150 533.333 400 733.333 400 733.333Z"
            fill="var(--primary)" stroke="#0000003d" stroke-width="66.6667" stroke-linejoin="round" />
          <path
            d="M400 416.666C455.228 416.666 500 371.895 500 316.667C500 261.438 455.228 216.667 400 216.667C344.772 216.667 300 261.438 300 316.667C300 371.895 344.772 416.666 400 416.666Z"
            fill="var(--primary)" stroke="white" stroke-width="66.6667" stroke-linejoin="round" />
        </svg>
      </div>
      <button [routerLink]="['/map']" class="btn btn-outline-secondary ml-2 glow-notification"><i
          class="fa-solid fa-map"></i> See on map</button>
    </div>
  </div>

  <app-nearby-all-services (onViewProducts)="viewProductDetails($event)" [userRegionId]="userRegionId"
    [userRegionName]="userRegionName" [hiddenCategoryTab]="hiddenCategoryTab"
    [userId]="userId"></app-nearby-all-services>
  <div class="container">
    @if (viewTabs) {
    <div style="position: relative; top: 0.5rem">
      <div class="my-2 w-100 title-text">
        <i class="fa-solid fa-bag-shopping"></i> Your Products
      </div>
      <app-my-tabs [tabs]="tabs" (tabChange)="updateSelMenu($event)">
        <div allTab>
          @if(areUsersProductsLoading){
          <div class="text-center w-100">
            Loading...
          </div>

          }
          @else if(!usersProducts?.length && isBrowser){
          <div class="text-center w-100">
            No product of your found in this filter...
          </div>


          }@else {
          <app-my-carousel-swiper [slider]="cat?.image" [navigation]="false" class="my-carousel-width-auto"
            [config]="{ slidesPerView: 'auto', spaceBetween: 10, pagination: false }">
            <div class="swiper-slide" *ngFor="let product of usersProducts">
              <common-product-card-view [list]="product"></common-product-card-view>

            </div>
          </app-my-carousel-swiper>
          }


        </div>
      </app-my-tabs>
    </div>
    }
  </div>
  <app-ask-carsouel [slides]="4"></app-ask-carsouel>

  <app-marketplace #marketplace [share]="true"></app-marketplace>
</div>